export enum LanguageCode {
  EN = 'en',
  RU = 'ru',
  UK = 'uk',
  UA = 'ua',
  PL = "pl",
  SK = "sk"
}
